import axios from 'axios';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import CardGroup from 'react-bootstrap/CardGroup';
import Form from 'react-bootstrap/Form';


function GestionAffichageSelection(props) {
    const [isLoading,setIsLoading] = useState(false)
    const [error,setError] = useState();
    const { idMatch } = useParams();
    const [majSelection,setMajSelection] = useState()
    const [selection,setSelection] = useState(props.joueur.selection.map(e => ({id : e.id_joueur, commentaire: e.commentaire, status : e.status})))
    const [commentaireEquipe, setCommentaireEquipe] = useState(props.joueur.match_commentaire[0].commentaire)
    const apiUrl = process.env.REACT_APP_API_URL;


    const handleSubmitMajListe = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      try {
        await axios.patch(`${apiUrl}/selection/maj/liste-joueur`, {
          idEquipe : props.userData.user.donnée.results[0].id_equipe,
          idMatch : idMatch
        }, {
          withCredentials: true
        });
  
        setError(null);
        setIsLoading(false);
        window.location.reload(); 

      } catch (error) {
        if (error.response) {
          setIsLoading(false)
          setError(error.response.data.message);
        } else {
          setIsLoading(false)
          setError(true);
        }
      }
    };


    const handleSubmitMajSelection = async (e) => {
      e.preventDefault();
      setIsLoading(true);
      try {
        await axios.patch(`${apiUrl}/selection/maj/selection`, {
          idEquipe : props.userData.user.donnée.results[0].id_equipe,
          idMatch : idMatch,
          selection : selection,
          commentaireEquipe : commentaireEquipe
        }, {
          withCredentials: true
        });
  
        setError(null);
        setIsLoading(false);
        window.location.reload(); 

      } catch (error) {
        if (error.response) {
          setIsLoading(false)
          setError(error.response.data.message);
        } else {
          setIsLoading(false)
          setError(true);
        }
      }
    };



    function MajCommentaire(id,commentaire){
      setSelection(selection.map(e => 
       e.id === id ? ({...e, commentaire: commentaire}) : e
      ));
    }

    function MajStatus(id,status){
      setSelection(selection.map(e => 
       e.id === id ? ({...e, status: status}) : e
      ));
    }

  return (
    <>
      {majSelection && (
        <Modal show={majSelection} onHide={() => setMajSelection(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Mettre à jour la sélection</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Voulez-vous vraiment mettre à jour la sélection pour le match {props.joueur.match[0].equipe_dom} - {props.joueur.match[0].equipe_ext} ?</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary"  onClick={() => setMajSelection(false)} >
              Annuler
            </Button>
            <Button variant="primary" onClick={(e) => handleSubmitMajSelection(e)} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
              Mettre à jour
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    {props.joueur.selection && props.joueur.match_commentaire && 
      <>
        <Card className="bg-dark text-white" style={{borderRadius: "var(--bs-card-border-radius)"}}>
              <Card.Img src="/img/matchArbitre.jpg" alt="Card image" />
              <Card.ImgOverlay>
                <div className="text-center mb-3">
                  <Card.Title><strong>Gestion de la sélection : {props.joueur.match[0].equipe_dom} - {props.joueur.match[0].equipe_ext}</strong></Card.Title>
                </div>
              </Card.ImgOverlay>
            </Card><br/>
        <CardGroup>
      {props.joueur.selection.map((joueur, j) => ( 
            <Card key={j}>
              <Card.Body>
                <div className="text-center mb-3">
                  <Card.Title><strong>{joueur.nom} {joueur.prenom}</strong> </Card.Title>
                </div> 
                <Card.Text>
                  <strong>Statut :</strong> {joueur.status} <br/>
                  <strong>Poste :</strong> {joueur.poste !== null ? `${joueur.poste}` : "?"} <br/>
                  <strong>Taille :</strong> {joueur.taile !== null ? `${joueur.taile} m` : "?"} <br/>
                  <strong>Poid :</strong> {joueur.poid !== null ? `${joueur.poid} kg` : "?"} <br/>
                  <strong>Pied fort :</strong> {joueur.pied_fort !== null ? `${joueur.pied_fort}` : "?"} <br/>
                </Card.Text>
              </Card.Body>
              <Card.Footer>
                <Form>
                <Form.Label>Statut</Form.Label>
                  <Form.Select aria-label="Default select example" onChange={(e) => MajStatus(joueur.id_joueur,e.target.value)} defaultValue={joueur.status}>
                    <option value="Pas sélectionné" disabled={joueur.status === 'Blessé'}>Pas sélectionné</option>
                    <option value="Sélectionné" disabled={joueur.status === 'Blessé'}>Sélectionné</option>
                    <option value="Blessé" disabled={joueur.status !== 'Blessé'}>Blessé</option>
                  </Form.Select>
                  <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Commentaire</Form.Label>
                    <Form.Control as="textarea" rows={3} disabled={joueur.status === 'Blessé'} onChange={(e) => MajCommentaire(joueur.id_joueur,e.target.value)} defaultValue={joueur.commentaire} />
                  </Form.Group>
                </Form>
              </Card.Footer>
          </Card>
      ))
      }
      </CardGroup>
     <br/> 
       <Card>
      <Card.Header>Soumettre la sélection pour le match {props.joueur.match[0].equipe_dom} - {props.joueur.match[0].equipe_ext}</Card.Header>
      <Card.Body>
      <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                    <Form.Label>Commentaire pour toute l'équipe</Form.Label>
                    <Form.Control as="textarea" rows={3} defaultValue={props.joueur.match_commentaire[0].commentaire} onChange={(e) => setCommentaireEquipe(e.target.value)} />
                  </Form.Group>
        <Card.Text><strong>Remarque : si des joueurs manquent à la sélection cliquer sur "Mettre à jour la liste".</strong></Card.Text>
        <Button variant="primary" onClick={(e) => { handleSubmitMajListe(e)}}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Mettre à jour la liste</Button>
        &nbsp;&nbsp;&nbsp;
        <Button variant="primary" onClick={() => { setMajSelection(true)}}  style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>Mettre à jour la sélection</Button>
      </Card.Body>
    </Card>
    <br/>
     </> 
  }
    {error && (
        <div id="alert-message" className="alert5" >
            <strong>ERROR ! </strong>{error} <span id="alert-text"></span>
        </div>
    )}
    {isLoading && (
        <div className="centered-content">
          <img src="/img/logo.png" alt="Logo" className="centered-logo" />
          <br/>
          <span className="loader"></span>
        </div>
    )}
  </>
  );
}

export default GestionAffichageSelection;